<template>
  <div>
    <v-card
      v-if="securityDepositAccess.read"
      v-show="!loading"
      elevation="0"
      class="card-container px-8 py-4"
    >
      <div>
        <v-data-table
          class="denser"
          :search="searchString"
          :headers="headers"
          :items="securityDeposits"
          :options.sync="options"
          :server-items-length="total"
          :loading="loading"
          loading-text="Loading... Please wait"
          no-data-text="All Security Deposits will appear here."
          multi-sort
          :footer-props="
            !mobile
              ? { 'items-per-page-options': [12, 24, 48, 96, 200] }
              : { 'items-per-page-options': [5] }
          "
          dense
        >
          <template v-slot:item="{ item }">
            <tr style="cursor: pointer" @click="showPreview(item)">
              <td>
                <p class="caption">{{ item.refNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.paymentRefNo }}</p>
              </td>
              <td v-if="type !== Types.UNIT">
                <a class="caption" @click="redirectBed(item)">
                  {{ item.unitName }}
                </a>
              </td>
              <td v-if="type !== Types.UNIT && type !== Types.USER">
                <p class="caption">
                  {{ item.tenantName }}
                </p>
              </td>
              <td>
                <p class="caption">{{ item.formattedAmount }}</p>
              </td>
              <td>
                <p class="caption">
                  {{ parsePaymentStatus(item.payment_details.status) }}
                </p>
              </td>
              <td>
                <p class="caption">{{ item.parsedRefundStatus }}</p>
              </td>
              <td>
                <p class="caption">{{ item.refundDate }}</p>
              </td>
              <td>
                <p class="caption">{{ item.formattedRefundedAmount }}</p>
              </td>
              <td>
                <div class="d-flex flex-row">
                  <action-button
                    :activate-condition="
                      item.payment_details.status === PaymentStatus.PENDING ||
                      item.payment_details.status === PaymentStatus.PAID_PARTIAL
                    "
                    :disabled-condition="!paidpaymentAccess.create"
                    title="Payment Received"
                    :action="() => paid(item)"
                    icon="mdi-check-decagram"
                    color="primary"
                  ></action-button>
                  <action-button
                    :activate-condition="
                      item.payment_details.status === PaymentStatus.PAID &&
                      (item.refundStatus === RefundStatus.APPROVED ||
                        item.refundStatus === RefundStatus.PARTIALLY_REFUNDED)
                    "
                    :disabled-condition="!securityDepositAccess.refund"
                    title="Refund"
                    :action="() => refund(item)"
                    icon="mdi-cash-refund"
                    color="primary"
                  ></action-button>
                  <action-button
                    :activate-condition="
                      item.refundStatus === RefundStatus.PENDING &&
                      item.paymentStatus === SecurityDepositPaymentStatus.PAID
                    "
                    title="Approve refund"
                    :action="() => approveRefund(item)"
                    icon="mdi-check"
                    color="primary"
                    :disabled-condition="!securityDepositAccess.approve_refund"
                  ></action-button>
                  <action-button
                    :activate-condition="
                      item.refundStatus !== RefundStatus.REFUNDED &&
                      item.refundStatus !== RefundStatus.REJECTED &&
                      item.refundStatus !== RefundStatus.FULLY_CONSUMED &&
                      item.paymentStatus === SecurityDepositPaymentStatus.PAID
                    "
                    :disabled-condition="!securityDepositAccess.reject_refund"
                    title="Reject refund"
                    :action="() => rejectRefund(item)"
                    icon="mdi-cancel"
                    color="error"
                  ></action-button>
                  <action-button
                    :activate-condition="true"
                    title="Update security deposit"
                    :action="() => update(item)"
                    icon="mdi-pencil"
                    color="primary"
                    :disabled-condition="
                      securityDepositAccess.update &&
                      (item.payment_details.status !== PaymentStatus.PENDING ||
                        item.refundStatus !== RefundStatus.PENDING)
                    "
                  ></action-button>
                  <action-button
                    :activate-condition="
                      item.payment_details.status === PaymentStatus.PENDING
                    "
                    :disabled-condition="!securityDepositAccess.cancel"
                    title="Cancel security deposit"
                    :action="() => cancel(item)"
                    icon="mdi-close"
                    color="error"
                  ></action-button>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-skeleton-loader
      v-show="loading"
      ref="skeleton"
      type="table"
      loading
      class="mx-auto"
    ></v-skeleton-loader>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <ConfirmPayment ref="confirmPayment"></ConfirmPayment>
    <UpdateSecurityDeposit
      ref="updateSecurityDeposit"
      @reload="reload"
    ></UpdateSecurityDeposit>
    <RefundSecurityDeposit
      ref="refundSecurityDeposit"
      @reload="reload"
    ></RefundSecurityDeposit>
    <preview-security-deposit
      ref="previewSecurityDeposit"
    ></preview-security-deposit>
    <reject-refund-security-deposit
      ref="rejectRefund"
      @reload="reload"
    ></reject-refund-security-deposit>
  </div>
</template>

<script>
import {
  RefundStatus,
  SecurityDepositPaymentStatus
} from '../../config/securityDeposit'
import { parsePaymentStatus, PaymentStatus } from '../../config/payment'
import ActionButton from '../ActionButton.vue'
import ConfirmPayment from '../payment/ConfirmPayment.vue'
import UpdateSecurityDeposit from '../securityDeposit/UpdateSecurityDeposit.vue'
import RefundSecurityDeposit from '../securityDeposit/RefundSecurityDeposit.vue'
import PreviewSecurityDeposit from '../securityDeposit/PreviewSecurityDeposit.vue'
import RejectRefundSecurityDeposit from '../securityDeposit/RejectRefundSecurityDeposit.vue'
import Hashids from 'hashids'

const hashids = new Hashids()

export default {
  components: {
    ActionButton,
    ConfirmPayment,
    UpdateSecurityDeposit,
    RefundSecurityDeposit,
    PreviewSecurityDeposit,
    RejectRefundSecurityDeposit
  },
  props: [
    'searchString',
    'selectedStatuses',
    'selectedCategories',
    'statusItems',
    'selectedTags',
    'searchTrigger',
    'leaseId',
    'tenantId',
    'type'
  ],
  data() {
    return {
      RefundStatus,
      PaymentStatus,
      SecurityDepositPaymentStatus,
      parsePaymentStatus,
      loading: true,
      total: 0,
      limit: 0,
      options: {},
      snackbar: false,
      snackbarMessage: '',
      Types: {
        UNIT: 'unit',
        USER: 'user'
      }
    }
  },
  computed: {
    securityDeposits() {
      return this.$store.getters['securityDeposits/getSecurityDeposits']
    },
    headers() {
      const headers = this.$store.getters['securityDeposits/getHeaders']

      switch (this.type) {
        case this.Types.UNIT:
          return headers.filter(
            (h) => !['unitName', 'tenantName'].includes(h.value)
          )
        case this.Types.USER:
          return headers.filter((h) => !['tenantName'].includes(h.value))
        default:
          return headers
      }
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    securityDepositAccess() {
      return this.$root.$roleAccess('security_deposit').access
    },
    paidpaymentAccess() {
      return this.$root.$roleAccess('paidpayment').access
    },
    units() {
      return this.$store.getters['units/getUnitsFlat']
    }
  },
  watch: {
    options: {
      async handler() {
        await this.searchAction()
      }
    },
    searchTrigger: {
      async handler() {
        await this.searchAction()
      }
    }
  },
  methods: {
    async searchAction() {
      // if (!this.selectedStatuses.length > 0) {
      //   return
      // }
      this.loading = true
      const { limit, count } = await this.$store.dispatch(
        'securityDeposits/searchSecurityDepositsAction',
        {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.selectedStatuses || [],
          categories: this.selectedCategories,
          tags: this.selectedTags,
          leaseId: this.leaseId,
          tenantId: this.tenantId
        }
      )

      this.loading = false
      this.limit = limit
      this.total = count
    },
    showPreview(item) {
      this.$refs.previewSecurityDeposit.open(item)
    },
    showPendingFeatureSnackMessage() {
      this.snackbarMessage = 'This feature is currently in development.'
      this.snackbar = true
    },
    refund(item) {
      this.$refs.refundSecurityDeposit.open(item)
    },
    async approveRefund(item) {
      const confirm = await this.$root.$confirm({
        title: 'Approve Refund',
        message: 'Are you sure you want to approve the refund?'
      })

      if (confirm) {
        this.$root.$setLoading(true)

        await this.$store.dispatch('securityDeposits/approveRefund', {
          securityDepositId: item.securityDepositId
        })

        this.$root.$setLoading(false)
        await this.$root.$confirm({
          title: 'Approve Refund',
          message: `The refund has been approved.`,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'success'
          }
        })
        this.reload()
      }
    },
    async rejectRefund(item) {
      this.$refs.rejectRefund.open(item)
    },
    update(item) {
      this.$refs.updateSecurityDeposit.open(item)
    },
    paid(item) {
      this.$refs.confirmPayment
        .open({ ...item.payment_details, tenantName: item.tenantName })
        .then(() => {
          this.reload()
        })
    },
    reload() {
      this.searchAction()
      this.$emit('securityDepositReload')
    },
    async redirectBed(item) {
      try {
        const unit = this.units.find((u) => u.leaseId === item.leaseId)
        if (!unit)
          await this.$router.push(`/user/${item.tenant_details.username}`)
        if (unit.bedId)
          await this.$router.push(`/bed/${hashids.encode(unit.bedId)}`)
      } catch (err) {
        // eslint-disable-next-line
        console.log(err.message)
      }
    },
    async cancel(item) {
      const confirm = await this.$root.$confirm({
        title: 'Cancel Security Deposit',
        message:
          'Are you sure you want to cancel the security deposit? This will also cancel the associated pending payment.'
      })

      if (confirm) {
        this.$root.$setLoading(true)

        await this.$store.dispatch('securityDeposits/cancel', {
          securityDepositId: item.securityDepositId
        })

        this.$root.$setLoading(false)
        await this.$root.$confirm({
          title: 'Cancel Security Deposit',
          message: `The security deposit has been cancelled.`,
          reconfirmOnly: true,
          confirmText: 'OK',
          options: {
            color: 'success'
          }
        })
        this.reload()
      }
    }
  }
}
</script>

<style scoped>
.v-card.card-container {
  border-radius: 12px !important;
}
</style>
